import React from 'react';
import { Divider, List, Skeleton, Typography } from 'antd';
import { useGetContacts } from 'api/contacts/use-get-contacts.ts';
import { ContactControl } from './components/contact-control';
import styles from './contact-list.module.scss';

const { Text } = Typography;

interface IContactsListProps {
  clientId: number;
}

export const ContactsList: React.FC<IContactsListProps> = (props) => {
  const { clientId } = props;

  const { data: contacts, isLoading } = useGetContacts({
    clientId: clientId,
    limit: 40,
  });

  return (
    <Skeleton loading={isLoading}>
      <List
        itemLayout='horizontal'
        dataSource={contacts?.data || []}
        renderItem={(contact) => (
          <List.Item key={contact.id} className={styles.item} actions={[<ContactControl contact={contact} />]}>
            <List.Item.Meta
              title={
                <>
                  <Text>{contact.name} </Text>
                  <Text type='secondary' className={styles.subtitle}>
                    {contact.role}
                  </Text>
                </>
              }
              description={
                <>
                  <span>{contact.phone}</span>
                  <Divider type='vertical' />
                  <span>{contact.email}</span>
                </>
              }
            />
          </List.Item>
        )}
      />
    </Skeleton>
  );
};
